import React from 'react';
import IconUserOutline from "@Icons/user/IconUserOutline";
import {PassengersTypeType} from "@Form/types/PassengersType.type";
import CountControl from "@Generic/controls/CountControl";
import useHandlePassenger from "@Form/features/passengers/hooks/useHandlePassenger";
import {FormVersionType} from "@Form/types/FormVersion.type";
import getFormVersionClassNameAggregator from "@Form/functions/getFormVersionClassNameAggregator";
import Row from "@Containers/components/Row";

interface PassengerGroupProps {
    passengerType: PassengersTypeType,
    fieldName: string,
    formVersion?: FormVersionType,
    count: number,
}

function PassengerGroup(props: PassengerGroupProps) {
    const {
        passengerType,
        fieldName,
        count,
        formVersion = "1",
    } = props;

    const {
        incrementControl,
        decrementControl,
    } = useHandlePassenger(passengerType)

    const {v} = getFormVersionClassNameAggregator(formVersion)

    return (
        <Row
            className={`gb--search${v()}__select--pax-add`}
            justify
            center
        >
            <IconUserOutline
                className="pax--icon"
            />
            <input
                type="text"
                name={fieldName}
                placeholder={fieldName}
                value={`${fieldName}`}
                readOnly
                disabled
            />
            <div className="pax--counter__wrapper">
                <CountControl
                    incrementControl={incrementControl}
                    decrementControl={decrementControl}
                    count={count}
                />
            </div>
        </Row>
    );
}

export default PassengerGroup;
